<template>
  <div>
    <v-dialog v-model="dialog" persistent width="650" transition="dialog-top-transition" content-class="bra-20">
      <v-card>
        <v-card-title>
          <span>{{ editando ? 'Editando' : 'Cadastrando' }}</span>

          <v-spacer />

          <v-btn icon @click="fecharDialog()" class="ml-n2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-7">
          <div class="d-flex">
            <div class="w-50-porcento mr-2">
              <SysGrupoAutocomplete
                v-model="editedItem.grupo"
                label="Selecione o Grupo*"
                outlined
                :disabled="editedItem.id > 0"
                :error-messages="grupoErros"
                @change="messageError = null"
              />
            </div>

            <div class="w-50-porcento ml-2">
              <SysFilialGrupoAutocomplete
                v-model="editedItem.filial"
                :id-grupo="editedItem.grupo || 0"
                label="Selecione a Filial*"
                outlined
                multiple
                :qtde-visivel-selecionados="5"
                :disabled="editedItem.id > 0"
                :error-messages="filialErros"
                @change="messageError = null"
              />
            </div>
          </div>

          <div class="d-flex">
            <div class="w-50-porcento mr-2">
              <v-select
                v-model="editedItem.pqr"
                label="Selecione a Curva Frequência*"
                :items="select.pqr"
                item-text="text"
                item-value="value"
                outlined
                :error-messages="pqrErros"
                @change="messageError = null"
              />
            </div>

            <div class="w-50-porcento ml-2">
              <v-select
                v-model="editedItem.xyz"
                label="Selecione a Curva Faturamento*"
                :items="select.xyz"
                item-text="text"
                item-value="value"
                outlined
                :error-messages="xyzErros"
                @change="messageError = null"
              />
            </div>
          </div>

          <text-field-formatador
            v-model="editedItem.tempo_cobertura_drp"
            label="Informe o Tempo de Cobertura*"
            outlined
            :remover-valor-irrelevante="true"
            inteiro
            :error-messages="tempoCoberturaErros"
            @focus="$event.target.select()"
            @keyup.enter="salvar()"
          ></text-field-formatador>
        </v-card-text>

        <v-card-actions class="d-flex mt-n5">
          <v-spacer />

          <v-btn text color="primary" @click="salvar()">
            salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TempoCoberturaAPI from '../../../api/drp/TempoCoberturaPorPopularidade'
import {required, minValue, maxValue} from 'vuelidate/lib/validators'
import TextFieldFormatador from "../../utils/TextFieldFormatadorDeValor";
import SysFilialGrupoAutocomplete from "../../utils/crud/SysFilialGrupoAutocomplete";
import SysGrupoAutocomplete from "../../utils/crud/SysGrupoAutocomplete";
import * as descricaoDeApelidosCurvas from "@/components/Diagnostico/CurvasCruzadas/ParametrizacaoDeCoberturas/CoberturasCurvasPadrao";

export default {
  name: 'NovoDialog',
  model: {
    prop: 'dialog',
    event: 'change-dialog'
  },
  components: {SysGrupoAutocomplete, SysFilialGrupoAutocomplete, TextFieldFormatador},
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    itemParaEdicao: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    messageError: null,
    editedItem: {
      id: '',
      grupo: '',
      filial: [],
      pqr: '',
      xyz: '',
      tempo_cobertura_drp: ''
    },
    select: {
      pqr: [
        { text: descricaoDeApelidosCurvas.descricao_pqr.p, value: 'P' },
        { text: descricaoDeApelidosCurvas.descricao_pqr.q, value: 'Q' },
        { text: descricaoDeApelidosCurvas.descricao_pqr.r, value: 'R' },
      ],
      xyz: [
        { text: descricaoDeApelidosCurvas.descricao_xyz.z, value: 'Z' },
        { text: descricaoDeApelidosCurvas.descricao_xyz.y, value: 'Y' },
        { text: descricaoDeApelidosCurvas.descricao_xyz.x, value: 'X' },
      ]
    },
    descricaoDeApelidosCurvas: descricaoDeApelidosCurvas,
  }),
  watch: {
    itemParaEdicao (item) {
      const {id, grupo, filial, pqr, xyz, tempo_cobertura_drp} = item

      this.editedItem = Object.assign({}, {id, grupo, filial: [filial], pqr, xyz, tempo_cobertura_drp})
    }
  },
  validations: {
    messageError: {
      duplicated () {
        return this.messageError === null
      }
    },
    editedItem: {
      grupo: {
        required
      },
      filial: {
        required
      },
      pqr: {
        required
      },
      xyz: {
        required
      },
      tempo_cobertura_drp: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(99999999)
      }
    }
  },
  computed: {
    editando () {
      return this.editedItem.id && this.editedItem.id > 0
    },
    grupoErros () {
      const errors = [];
      if (!this.$v.editedItem.grupo.$dirty) return errors;
      !this.$v.editedItem.grupo.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    filialErros () {
      const errors = [];
      if (!this.$v.editedItem.filial.$dirty) return errors;
      !this.$v.editedItem.filial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    pqrErros () {
      const errors = [];
      if (!this.$v.editedItem.pqr.$dirty) return errors;
      !this.$v.editedItem.pqr.required && errors.push("Campo Obrigatório.");
      !this.$v.messageError.duplicated && errors.push("Tentativa de cadastro duplicado.");
      return errors;
    },
    xyzErros () {
      const errors = [];
      if (!this.$v.editedItem.xyz.$dirty) return errors;
      !this.$v.editedItem.xyz.required && errors.push("Campo Obrigatório.");
      !this.$v.messageError.duplicated && errors.push("Tentativa de cadastro duplicado.");
      return errors;
    },
    tempoCoberturaErros () {
      const errors = [];
      if (!this.$v.editedItem.tempo_cobertura_drp.$dirty) return errors;
      !this.$v.editedItem.tempo_cobertura_drp.required && errors.push("Campo Obrigatório.");
      !this.$v.editedItem.tempo_cobertura_drp.minValue && errors.push("Valor mínimo é 1.");
      !this.$v.editedItem.tempo_cobertura_drp.maxValue && errors.push("Valor máximo é 99.999.999.");
      return errors;
    }
  },
  methods: {
    salvar () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        this.$store.dispatch(
          "loading/addRequisicao",
          TempoCoberturaAPI.store(headers, this.editedItem)
            .then((response) => {
              const {token, messageError} = response.data;
              localStorage.token = token

              if (!messageError) {
                this.fecharDialog()
                this.$emit('atualizar-lista', true)
              } else {
                this.messageError = messageError
              }
            })
            .catch(() => this.Helpers.logout())
        );
      }
    },
    fecharDialog () {
      this.$emit('change-dialog', false)
      this.messageError = null
      this.$v.$reset()
      this.editedItem = {id: '', grupo: '', filial: '',pqr: '', xyz: '', tempo_cobertura_drp: ''}
    }
  }
}
</script>

<style scoped>

</style>
